import { LitElement, css, html, nothing } from 'lit';
import {customElement} from "lit/decorators.js";
import {getGlobalStyleSheets} from "../../global-styles";
import { classMap } from 'lit/directives/class-map.js';
import { AtlFormControlPlaceholderProps } from './placeholders.props';

import * as PlaceholderTags from './placeholders.tagnames';
import { SpanPlaceholderSizes } from './placeholders.enums';

@customElement(PlaceholderTags.FormControl)
export class AtlFormControlPlaceholder extends LitElement implements AtlFormControlPlaceholderProps {

    declare showButton?: boolean;
    declare showLabel?: boolean;

    static properties = {
        showButton: { attribute: 'show-button', type: Boolean },
        showLabel: { attribute: 'show-label', type: Boolean }
    }

    static styles = [
        ...getGlobalStyleSheets(),
        css`            
            .button-field::part(placeholder-span) {
                height: 100%;
            }
            atlantis-button::part(button) {
                margin-left: calc(var(--bs-border-width)* -1);
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        `
    ];

    private _renderLabel = () => {
        if (!this.showLabel) return nothing;

        return html`
            <label class="pe-2">
                <atlantis-span-placeholder size="${SpanPlaceholderSizes.Smaller}" glow></atlantis-span-placeholder>              
            </label>
        `;
    }

    private _renderButton = () => {
        if (!this.showButton) return nothing;

        return html`
            <atlantis-button hiddenText="Loading">                    
                <atlantis-span-placeholder size="${SpanPlaceholderSizes.Smaller}" glow></atlantis-span-placeholder>
            </atlantis-button> 
        `;
    }

    render() {
        return html`${this._renderLabel()}
            <span class="placeholder-glow input-group">
                <atlantis-span-placeholder 
                    class=${classMap({"button-field": this.showButton === true })} 
                    size="${SpanPlaceholderSizes.Medium}" 
                    glow
                ></atlantis-span-placeholder>
                ${this._renderButton()}
            </span>
        `;
    }
}